import { isCodeDiscount } from "@app/modules/checkout/utils/cart-v2";
import type { CheckoutReduxStateV2 } from "@app/types/checkout-v2-types";
import type { ChargeItem } from "@app/types/napi-v2-charges-types";

export const getCartDiscountAmount = (state: CheckoutReduxStateV2) => {
  const discount_item =
    state.cart.charges.items.find<ChargeItem>(isCodeDiscount);
  return discount_item ? discount_item.amount : null;
};
